import React from "react";
import {LOCO_HEADER_COLOR, REPAIR_SHOPS_ICONS, REPAIR_SHOPS_IMAGES} from "../GameStyleUI";
import {INFRA_TYPE, REPAIR_SHOP_NAMES} from "../../../constants/Constants";
import GameButtonWithIcon from "../GameButtonWithIcon";
import CurrencyCard from "../GeneralCards/CurrencyCard";
import brigade_icon from "../../../images/gameplay_ui/icons/brigades_icon.svg";
import brigade_chips_icon from "../../../images/gameplay_ui/icons/brigade_chips_icon.svg";
import GameData from "../../../gameplay/model/GameData";
import GameController from "../../../gameplay/controllers/GameController";
import BuyWorkhourPopup from "../Popups/BuyWorkhourPopup";
import BuyPartsPopup from "../Popups/BuyPartsPopup";

export default class StationPanel_RepairCard extends React.Component {
    constructor(props) {
        super(props);
        this.popup = null;
    }

    handlePopup(thePopup) {
        let currentType = this.popup ? this.popup.type.name : "";
        this.popup = currentType === thePopup.type.name ? null : thePopup;

        this.props.updatePopup(this.props.type);
    }

    closeByX(popup) {
        let equal = GameController.sameCard(this.popup.props, popup.props);

        if (equal) {
            this.popup = null;
            this.props.updatePopup(this.props.type);
        }
    }


    render() {
        if (!this.props.canShow)
            this.popup = null;

        let repairShop = GameData.CurrentGame.getRepairShopByType(this.props.type);
        let mainStyle = {
            width: "244px",
            height: "50px",
            background: "rgba(0, 0, 0, 0.5)",
            borderRadius: "3px",
            position: "relative"
        }
        let container = {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "5px"
        }

        let colors = LOCO_HEADER_COLOR[this.props.type];
        return <div style={mainStyle}>
            <div style={{position: "absolute", bottom: "60px"}}>
                {this.props.canShow && this.popup}
            </div>
            <div style={container}>
                <img alt={"icon"} src={REPAIR_SHOPS_IMAGES[this.props.type]} title={REPAIR_SHOP_NAMES[this.props.type]}/>
                <GameButtonWithIcon
                    tooltip={"Запчасти"}
                    colorStart={colors[0]}
                    colorEnd={colors[1]}
                    icon={REPAIR_SHOPS_ICONS[this.props.type]}
                    width={58}
                    height={30}
                    title={repairShop.partsType === INFRA_TYPE ?
                        GameController.calculateAvaliablePartsPath(repairShop)
                        : GameController.calculateParts(repairShop)}
                    onClick={()=>{
                        this.handlePopup(<BuyPartsPopup
                                id={repairShop.id}
                                icon={REPAIR_SHOPS_ICONS[this.props.type]}
                                teamID={this.props.teamID}
                                onClose={this.closeByX.bind(this)}
                            />);
                        this.forceUpdate();
                    }}
                />
                <CurrencyCard
                    title={"Ремонтные бригады"}
                    icon={brigade_icon}
                    value={repairShop.brigades + GameData.CurrentGame.getRentedBrigades("reairshop", repairShop.id)}
                    size={20}
                    fontSize={20}
                />
                <GameButtonWithIcon
                    tooltip={"Трудозатраты"}
                    colorStart={colors[0]}
                    colorEnd={colors[1]}
                    icon={brigade_chips_icon}
                    width={58}
                    height={30}
                    title={repairShop.partsType === INFRA_TYPE ?
                        GameController.calculateAvaliableBrigadesChipsPath(repairShop):
                        GameController.calculateRepairBrigadeChips(repairShop)}
                    style={{
                        marginRight: "5px"
                    }}
                    onClick={()=>{
                        this.handlePopup(<BuyWorkhourPopup
                                parent={this}
                                id={repairShop.id}
                                teamID={this.props.teamID}
                                type={"reairshop"}
                                brigades={repairShop.brigades}
                                additionalChips={repairShop.additionalChips}
                                onClose={this.closeByX.bind(this)}
                            />);
                        this.forceUpdate();

                    }}
                />
            </div>
        </div>
    }
}
